

const basePageUrl=`${window.location.origin}/umbraco/surface/page/`;
const baseApiUrl=`${window.location.origin}`;
//const basePageUrl = `http://localhost:60371/umbraco/surface/page/`;
//const baseApiUrl = `http://localhost:60371`;
let snowmindsApp = {
  homepageApi: `${baseApiUrl}/homeapi/pagedata`,
  homebannerpageApi: `${basePageUrl}getbanner`,
  homefilterApi: `${baseApiUrl}/filterapi/getfilters`,
  searchApi: `${baseApiUrl}/searchapi/trips/`,
  navigationpageApi: `${basePageUrl}getnavigation/`,
  getallroutesApi: `${basePageUrl}getallroutes`,
  getcheckoutform: `${basePageUrl}getcheckoutformcontent`,
  fetchcheckoutdataapi: `${baseApiUrl}/checkout/data`,
  saveabonandcartapi: `${baseApiUrl}/checkout/saveabandonedcart`,
  getformdataapi: `${baseApiUrl}/checkout/abandonedcartformdata`,
  getaddonsapi: `${baseApiUrl}/checkout/checkoutaddondata`,
  saveOrderApi: `${baseApiUrl}/checkout/savetrip`,
  getbookingdetails: `${baseApiUrl}/checkout/bookingdetails`,
  applyDiscountApi: `${baseApiUrl}/checkout/discount`,
  productDetailApi: `${baseApiUrl}/productdetailapi/get`,
  getProductMsLines: `${baseApiUrl}/productdetailapi/getpmsline`,
  getRelatedProducts: `${baseApiUrl}/retatedproductsapi/get`,
  savefollowleadapi: `${baseApiUrl}/checkout/savefollowleads`,
  travelDoc:{
    getApi:`${baseApiUrl}/traveldoc/get`,
    saveQandAnsApi:`${baseApiUrl}/traveldoc/saveQandA`
  },
  getGridApi:{
    productGridApi: `${baseApiUrl}/gridmoduledetailapi/getproductgridcontents`,
    pageGridApi: `${baseApiUrl}/gridmoduledetailapi/getpagegridcontents`,
    reusableGridApi: `${baseApiUrl}/gridmoduledetailapi/getreusablegridcontents`
  } ,
  getdestination:{
      landingpageApi:`${baseApiUrl}/destinationapi/getdescountrycollection`,
      countrypageApi:`${baseApiUrl}/destinationapi/getdescountry`,
      locationApi:`${baseApiUrl}/destinationapi/getdeslocation`,
      locationProductsApi:`${baseApiUrl}/destinationapi/getallproductsbythislocation`,
      countryProductsApi:`${baseApiUrl}/destinationapi/getallproductsbythiscountry`
      
  } ,
  getcategoryPageApi:{
    landingpageApi:`${baseApiUrl}/categoryapi/getallcategories`,
    categorypageApi:`${baseApiUrl}/categoryapi/getcurrentcategory`,
    catproductsApi:`${baseApiUrl}/categoryapi/getallproductsbythiscat`
  },
  getcontentPageApi:`${baseApiUrl}/contentapi/getpage`,
  registerPage:{
    pageApi:`${baseApiUrl}/register/getpagedata`,
    saveApi:`${baseApiUrl}/register/save`
  },
  loginPage:{
    pageApi:`${baseApiUrl}/authenticatecustomer/getpagedata`,
    loginApi:`${baseApiUrl}/authenticatecustomer/login`,
    logoutApi:`${baseApiUrl}/authenticatecustomer/logout`

  },
  forgotPage:{
    pageApi:`${baseApiUrl}/customerprofile/getpagedata`,
    forgotmypassApi:`${baseApiUrl}/customerprofile/iforgotmypassword`,
    resetPass:`${baseApiUrl}/customerprofile/resetpassplease`
  }
}



export const snowmindsConfig = {
  getSnowMindsConfiguration() {
    return snowmindsApp
  },
  setfilterdata(selectedfilter, data) {

    return null
  }

}